import React from 'react'
import { useAppSelector } from '../../../ducks/hooks'
import {selectNetworkError, selectPathName, selectRefreshNeeded} from '../../../ducks/app'
import Breadcrumb from '../Breadcrumb'
import {Button} from 'antd';
import {Outlet} from "react-router";

const AppContent: React.FC = () => {
  const pathName = useAppSelector(selectPathName) || '';

  // useEffect(() => {
  //   if (isUpdatingContent) {
  //     dispatch(setUpdatingContent(false));
  //   }
  // }, [isUpdatingContent]);

  const refreshNeeded = useAppSelector(selectRefreshNeeded);
  const networkError = useAppSelector(selectNetworkError);
  return refreshNeeded ? (
    <div className="utils__content">
      <h5>Updates to MyNjAppeal are now available. Click the button to continue.</h5>
      <span>
        <Button
          onClick={() => {
            window.location.reload();
          }}
          // icon="check"
          size="middle"
          type="primary"
          style={{marginTop:"10px"}}
        >
          Refresh Page
        </Button>
      </span>
    </div>
  ) : (
    <div className="utils__content">
      <Breadcrumb name={pathName} />
      {networkError &&
        <div style={{color:"red",fontSize:"2em",fontWeight:"bold"}}>A network error has occurred. Please close the browser and try again.</div>
      }
      <div className="outlet_wrapper">
        <Outlet />
      </div>
    </div>
  );
}

export default AppContent;
